<div
  class="selectDropdown selectDropdown--tags"
  [ngStyle]="{ width: isMobile ? 'unset' : dropdownWidth }"
  >
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  <pp-search-box
    [ppPlaceholder]="'Filter tags'"
    (ppAction)="setSearchBox($event)"
    [ppFocusOnInit]="true"
    ppSize="wide"
    class="dropdown__searchBar"
  ></pp-search-box>

  @if (message) {
    <div class="warning__message">
      @if (message) {
        {{ message }}
      }
      @if (filteredItems?.length === 0 && !message) {
        {{ 'no_search_result' | ppTranslate }}
      }
    </div>
  }

  <ul id="tagListElement" class="dropdownWrapper dropdownWrapper--scrollbar">
    @for (item of filteredItems; track item) {
      <li
        class="ppTag_list"
        (click)="selectItem(item)"
        (ppOnRendered)="updateDropdownWidth($event, item)"
        >
        <pp-tag [ppText]="item" [ppDisabled]="true"></pp-tag>
      </li>
    }
  </ul>

  @if (!hideButtons) {
    <div class="tags__buttons">
      <pp-button ppStyle="secondary" (ppAction)="clearAll()">
        {{ 'clear_all' | ppTranslate }}
      </pp-button>
      <pp-button ppStyle="primary" (ppAction)="hideDropdown()">
        {{ 'done' | ppTranslate }}
      </pp-button>
    </div>
  }

  @if (noneAccess) {
    <div class="tags__buttons">
      <pp-button ppStyle="primary" (ppAction)="clearAll()">
        {{ 'unrestrict_tag_access' | ppTranslate }}
      </pp-button>
    </div>
  }
</div>
